import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { TranslatedString } from 'models/translated-string';

export type TextAlertType = 'warning' | 'success' | 'success-strong' | 'error' | 'neutral' | 'info';

@Component({
  selector: 'cs-text-alert',
  templateUrl: 'cs-text-alert.html',
  host: { 'class': 'text-alert' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTextAlert {
  @Input() type: TextAlertType = 'warning';
  @HostBinding('attr.type') get typeAttr() { return this.type; }
  @Input() message?: TranslatedString;
  @Input() icon?: string; // Optional custom icon name

  get iconName(): string {
    // if custom icon is provided, use that
    if (this.icon) {
      return this.icon;
    }

    // otherwise use default based on type
    switch (this.type) {
      case 'success':
        return 'thumbs-up';
      case 'success-strong':
        return 'thumbs-up';
      case 'error':
        return 'warning';
      case 'neutral':
        return 'warning';
      case 'info':
        return 'information-circle';
      case 'warning':
      default:
        return 'warning';
    }
  }
}
